export default __webpack_public_path__ + "static/GRID22-breakdown-fr-175788a99ceac6dbac8a315165668e5a.png";